import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';

const ANALYTICS_SUBJECT_ID_REQUEST_BUNDLE = 'requestBundle';
const ANALYTICS_SUBJECT_ID_SUBMIT_BUNDLE_RESPONSE = 'submitBundleResponse';

export const useBundleAnalytics = () => {
  const fireEvent = useAnalyticsEvents();

  const trackRequestBundleClick = ({
    bundleId,
    section,
  }: {
    bundleId: string;
    section: 'hero' | 'footer';
  }) => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_REQUEST_BUNDLE,
      attributes: {
        bundleId,
        section,
        source: 'bundlePage',
      },
    });
  };

  const trackSubmitResponseClick = ({
    bundleId,
    pricingPreference,
    discoveryPreferences,
    status,
  }: {
    bundleId: string;
    pricingPreference: string;
    discoveryPreferences: string[];
    status: 'success' | 'failure';
  }) => {
    fireEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_SUBMIT_BUNDLE_RESPONSE,
      attributes: {
        bundleId,
        pricingPreference,
        discoveryPreferences,
        status,
        source: 'bundlePage',
      },
    });
  };

  return {
    trackRequestBundleClick,
    trackSubmitResponseClick,
  };
};
